module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('component-footer')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "shop-page padding-top-100 padding-bottom-100"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', [_vm._v("setting up your account....")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cd53713"}!./src/pages/Manage/template.html
// module id = 258
// module chunks = 0